import type { Converter, ConverterType } from './types';

export type { Converter };
import { linearConvert } from './handlers/linear';
import { scfmAcfmConvert } from './handlers/scfm-acfm';
import { tempConvert } from './handlers/temperature';
import { headPressureConvert } from './handlers/head-pressure';
import { psigPsiaConvert } from './handlers/psig-psia';
import { formulaConvert } from './handlers/formula';

type Handler = (
  c: Converter,
  value: number,
  fromU: string,
  toU: string,
  conds: Record<string, number>
) => number;

const handlers: Record<ConverterType, Handler> = {
  linear: (_c, v, fromU, toU) => linearConvert(v, fromU, toU),
  temperature: (_c, v, fromU, toU) => tempConvert(v, fromU, toU),
  scfm_acfm: (c, v, fromU, toU, conds) =>
    scfmAcfmConvert(v, fromU, toU, conds, c.constants ?? {}),
  head_pressure: (_c, v, fromU, toU, conds) => headPressureConvert(v, fromU, toU, conds),
  pressure_head: (_c, v, fromU, toU, conds) => headPressureConvert(v, fromU, toU, conds),
  psig_psia: (_c, v, fromU, toU, conds) => psigPsiaConvert(v, fromU, toU, conds),
  formula: (c, v, fromU, toU, conds) => formulaConvert(c, v, fromU, toU, conds),
  control_valve_cv_water: () => { throw new Error('CV water not used in MVP — see spec section 12'); },
  control_valve_cv_steam: () => { throw new Error('CV steam not used in MVP'); },
  control_valve_cv_gas: () => { throw new Error('CV gas not used in MVP'); },
  npsh: () => { throw new Error('NPSH not used in MVP'); },
  formula_custom: () => { throw new Error('formula_custom not used in MVP'); }
};

export function convert(
  c: Converter,
  value: number,
  fromU: string,
  toU: string,
  conds: Record<string, number> = {}
): number {
  const handler = handlers[c.type];
  if (!handler) throw new Error(`No handler for type ${c.type}`);
  return handler(c, value, fromU, toU, conds);
}
